"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TdpGenerator = void 0;
/**
 * @author huajiezhang@microsoft.com
 */
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const error_1 = require("../../../error");
const constants_1 = require("../../../question/constants");
const developerPortalScaffoldUtils_1 = require("../../developerPortalScaffoldUtils");
const defaultGenerator_1 = require("../defaultGenerator");
const generator_1 = require("../generator");
/**
 * TdpGenerator is used to generate code from TDP app definition.
 */
class TdpGenerator extends defaultGenerator_1.DefaultTemplateGenerator {
    constructor() {
        super(...arguments);
        this.componentName = "tdp-generator";
    }
    // activation condition
    activate(context, inputs) {
        // Reuse some templates which are handled by other generators
        return inputs.teamsAppFromTdp !== undefined;
    }
    async getTemplateInfos(context, inputs, destinationPath, actionContext) {
        const templateName = inputs[constants_1.QuestionNames.TemplateName];
        if (!templateName) {
            return (0, teamsfx_api_1.err)(new error_1.InputValidationError("teamsAppFromTdp", "Invalid App Definition", "TdpGenerator"));
        }
        const appName = inputs[constants_1.QuestionNames.AppName];
        const safeProjectNameFromVS = inputs[constants_1.QuestionNames.SafeProjectName];
        const isNet8 = !inputs.targetFramework || inputs.targetFramework === "net8.0"; // used by SSR Tab
        const language = inputs[constants_1.QuestionNames.ProgrammingLanguage];
        return Promise.resolve((0, teamsfx_api_1.ok)([
            {
                templateName: templateName,
                language: language,
                replaceMap: Object.assign(Object.assign({}, generator_1.Generator.getDefaultVariables(appName, safeProjectNameFromVS, inputs.targetFramework, inputs.placeProjectFileInSolutionDir === "true")), { IsNet8Framework: isNet8 ? "true" : "" }),
            },
        ]));
    }
    async post(context, inputs, destinationPath, actionContext) {
        const res = await developerPortalScaffoldUtils_1.developerPortalScaffoldUtils.updateFilesForTdp(context, inputs.teamsAppFromTdp, inputs);
        if (res.isErr()) {
            return (0, teamsfx_api_1.err)(res.error);
        }
        return (0, teamsfx_api_1.ok)({});
    }
}
exports.TdpGenerator = TdpGenerator;
//# sourceMappingURL=tdpGenerator.js.map